import { formatDayDotLetter, formatDayLabel } from '../../utils/lineupFormat';

/**
 * One 14×14 day badge per festival day. Lit when member attendance overlaps
 * the viewing user's attendance (not merely when the member is attending).
 */
export default function DayDots({
  days = [],
  attendingDays = [],
  viewerAttendingDays = null,
  emptyLabel = 'No days yet',
}) {
  if (days.length === 0) return null;

  const memberAttending = new Set(attendingDays);
  const viewerAttending =
    viewerAttendingDays != null ? new Set(viewerAttendingDays) : memberAttending;

  const litDays = days.filter((day) => memberAttending.has(day) && viewerAttending.has(day));
  const goingLabel = litDays.map((day) => formatDayLabel(day)).join(', ');

  return (
    <span className="flex shrink-0 items-center gap-1" title={goingLabel || undefined}>
      <span className="sr-only">{goingLabel ? `Shared days: ${goingLabel}` : emptyLabel}</span>
      {days.map((day) => {
        const lit = memberAttending.has(day) && viewerAttending.has(day);
        return (
          <span key={day} aria-hidden className={`day-dot ${lit ? 'lit' : 'unlit'}`}>
            {formatDayDotLetter(day)}
          </span>
        );
      })}
    </span>
  );
}
